export default "__VITE_ASSET__CKo3E8ac__"